module.exports = {
  title: '权限设置',
  route: {
    path: '/system-manage',
    children: {
      path: 'manage-role-permission',
    },
  },
};
